import * as utils from './plot-bands.utils';

export function preRender(data, options) {
  const plotBands = utils.applyLineHeight(options);

  data.xAxis.plotBands = plotBands || [];

  return data;
}
